module.exports = __webpack_public_path__ + "premier_token.320acd88.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/token_earning/premier_token.png
// module id = 2528
// module chunks = 0